import { MetroLineNote } from "@/components/MetroLineNote";

// Subject guides are a branch line into Pick and Course.
export const SubjectsLineNote = () => (
  <MetroLineNote line="Subjects" colour="#175D51" testId="student-guide-subjects-line" stops={[
    { label: "Pick", to: "/beta/course-fit", testId: "subjects-line-to-pick" },
    { label: "Course", to: "/admission", testId: "subjects-line-to-course" },
  ]} />
);
